<template>
  <el-row class="tac">
    <el-col class="max-w-full w-full">
      <el-menu v-if="showMenu" :default-active="activeMenu">
        <div :key="item.id" v-for="item in routerLinks">
          <router-link :to="item.routerLink">
            <el-menu-item :index="item.id" class="border-b">
              <i v-bind:class="item.icon"></i>
              <span class="font-semibold">{{ item.title }}</span>
            </el-menu-item>
          </router-link>
          <div class="separator"></div>
        </div>
        <el-menu-item index="3" @click="openSettingsMenu()">
          <i class="el-icon-s-tools"></i>
          <span class="font-semibold">Settings</span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
  <el-drawer @close="drawerClosed" title="Item detail" v-model="showSettings" :with-header="false">
    <settings-component></settings-component>
  </el-drawer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SettingsComponent from '../../components/settings.vue';

export default defineComponent({
  name: 'MenuComponent',
  components: {
    SettingsComponent,
  },
  data: function () {
    return {
      activeMenu: '1',
      showSettings: false,
      showMenu: true,
      orderState: false,
      routerLinks: [
        {
          id: '1',
          title: 'Dashboard',
          icon: 'el-icon-menu',
          routerLink: '/tsas/admin/dashboard',
        },
        {
          id: '2',
          title: 'Orders',
          icon: 'el-icon-shopping-cart-full',
          routerLink: '/tsas/admin/orders',
        },
      ],
    };
  },
  created() {
    this.activeMenu = '1';
    // Set the selected menu on refresh
    this.updateSelectedMenu();
  },
  watch: {
    $route() {
      // Watch on route change and update selected menu
      this.updateSelectedMenu();
    },
  },
  methods: {
    openSettingsMenu: function () {
      this.showSettings = !this.showSettings;
    },
    updateSelectedMenu() {
      this.activeMenu = '1';
      const currentPathname = window.location.pathname; // browsers native way to get pathname
      const matchingRoute = this.routerLinks.find((link) => currentPathname.includes(link.routerLink));
      // Find the route with current pathname and set its id as current route
      // If not found id 1 will stay as selected
      if (matchingRoute) {
        this.activeMenu = matchingRoute.id;
      }
      return matchingRoute;
    },
    drawerClosed() {
      this.updateSelectedMenu();
      this.showMenu = false;
      setTimeout(() => {
        this.showMenu = true;
      }, 0);
    },
  },
});
</script>

<style lang="scss" scoped>
.el-menu {
  border: none;
}

.separator {
  border-top: 1px solid #e1e7ee;
}
</style>
